module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/bg-container-pink-dac38152e5d72d263521ac246b9e9658.png";